import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clubQueryKeys } from "../club";
import { clubAsPublicQueryKeys } from "../clubAsPublic";
import { kisiQueryKeys } from "./kisiQueryKeys";

export function useMutationKisiInitialize({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      kisiPlaceId,
      membershipToGroupMap,
      facilityToGroupMap,
    }: {
      kisiPlaceId: Parameters<ApiType["kisiApi"]["initialize"]>[0];
      membershipToGroupMap: Parameters<ApiType["kisiApi"]["initialize"]>[1];
      facilityToGroupMap: Parameters<ApiType["kisiApi"]["initialize"]>[2];
    }) => {
      return api.kisiApi.initialize(
        kisiPlaceId,
        membershipToGroupMap,
        facilityToGroupMap,
      );
    },
    onSuccess: () => {
      Promise.all([
        queryClient.invalidateQueries({ queryKey: kisiQueryKeys.all() }),
        queryClient.invalidateQueries({
          queryKey: clubAsPublicQueryKeys.all(),
        }),
        queryClient.invalidateQueries({ queryKey: clubQueryKeys.all() }),
      ]);
    },
  });
}
